import React from "react";
import { format } from 'date-fns'
import classNames from "classnames";
import "./VersionsItem.scss";

const VersionsItem = ({
  children,
  id,
  lastUpdate,
  size,
  text,
  type,
  updatedBy,
  isBlock,
  onClick,
  isActive,
  fileIconPath,
}) => {
  return (
    <div
      className={classNames({
        "versions-item": true,
        "versions-item--active": isActive,
      })}
      onClick={onClick}
    >
      <div className="versions-item__wrapper">
        <div
          className="versions-item__image"
          style={{
            backgroundImage: `url('${fileIconPath}')`,
          }}
        />

        <p
          className="versions-item__text"
          title={text}
        >
          {text}
        </p>
      </div>

      <div className="versions-item__wrapper">
        <p
          className="versions-item__lastUpdate"
          title={lastUpdate}
        >
          {format(new Date(lastUpdate * 1000), 'MM.dd.yyyy; HH:mm')}
        </p>

        <p
          className="versions-item__updatedBy"
          title={updatedBy}
        >
          {updatedBy}
        </p>
      </div>
    </div>
  );
};

export default VersionsItem;
